/** Email in (I6): the shapes of `/api/internal/mail`. */

export interface Condition {
  field: string;
  op?: "contains" | "is" | "matches";
  value?: string;
}

export interface Actions {
  workspace?: string;
  to?: "task" | "tray";
  group?: string;
  tags?: string[];
  contexts?: string[];
  priority?: "high" | "normal" | "low";
  energy?: number;
  estimateMin?: number;
  with?: string[];
  attachments?: "keep" | "drop";
  ignore?: boolean;
  anySender?: boolean;
}

export interface Rule {
  id: string;
  name: string;
  when: Condition[];
  then: Actions;
  off?: boolean;
}

export interface Account {
  id: number;
  name: string;
  host: string;
  port: number;
  security: "ssl" | "starttls" | "plain";
  username: string;
  folder: string;
  doneFolder: string;
  workspace: string;
  to: "task" | "tray";
  allowed: string[];
  requireAuth: boolean;
  rules: Rule[];
  mode: "first" | "all";
  enabled: boolean;
  lastPollAt: string | null;
  lastError: string;
  leftAlone: { from: string; subject: string; reason: string; at: string }[];
}

export interface TestResult {
  from: string;
  subject: string;
  outcome: "task" | "tray" | "thread" | "ignored" | "left";
  reason?: string;
  workspace?: string;
  rules: string[];
  actions?: Actions;
}

/** Fields that compare text; the others are yes/no or take a fixed value. */
export const TEXT_FIELDS = ["recipient", "plus", "sender", "senderName", "subject", "body", "listId"];
export const FIELDS = [
  ...TEXT_FIELDS,
  "senderDomain",
  "hasAttachment",
  "attachmentType",
  "invitation",
  "highPriority",
  "weekday",
  "workHours",
];
/** Fields without a value: the condition is the field itself. */
export const FLAG_FIELDS = ["hasAttachment", "invitation", "highPriority", "weekday"];

export async function mailCall<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api/internal/mail${path}`, {
    method,
    credentials: "same-origin",
    headers: body === undefined ? {} : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await res.json()) as T & { error?: string };
  if (!res.ok) throw new Error(data.error ?? "generic");
  return data;
}

export const newRuleId = () => `r${Date.now().toString(36)}${Math.random().toString(36).slice(2, 5)}`;
